/**
 * AI-generated insight. Accent-tinted surface with a small "AI" badge.
 *
 * Style is spec'd in CLAUDE.md: bg = accent + 0a (~4% opacity),
 * border = accent + 30 (~19% opacity), badge is 18×18px, 4px radius,
 * 9px bold white "AI".
 *
 * Usage:
 *   <InsightCard>
 *     Your email campaigns are driving 74% of traffic spikes…
 *   </InsightCard>
 */
export function InsightCard({ children }) {
  return (
    <div className="bg-accent-bg border border-accent-border rounded-card px-4 py-3.5 flex gap-3 items-start">
      <span
        className="bg-accent text-white font-bold flex items-center justify-center flex-shrink-0 select-none"
        style={{
          width: 18,
          height: 18,
          borderRadius: 4,
          fontSize: 9,
          letterSpacing: "0.02em",
          marginTop: 1,
        }}
      >
        AI
      </span>
      <div className="text-[12px] text-text-secondary leading-[1.55]">
        {children}
      </div>
    </div>
  );
}
